var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorExitCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26881",
    "data-name": "Group 26881",
    transform: "translate(-536.493 -477.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26872",
    "data-name": "Group 26872",
    transform: "translate(-1006.57 -763.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1536",
    "data-name": "Ellipse 1536",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1543.063 1241.486)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26873",
    "data-name": "Group 26873",
    transform: "translate(-6572.507 4251.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-logout",
    "data-name": "001-logout",
    transform: "translate(7120 -3764.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M6.124,5.311a.408.408,0,0,0-.408.408V7.353a.409.409,0,0,1-.408.408H4.083V1.637A.823.823,0,0,0,3.527.861L3.406.82h1.9a.409.409,0,0,1,.408.408V2.453a.408.408,0,1,0,.816,0V1.229A1.226,1.226,0,0,0,5.307,0H.919A.321.321,0,0,0,.875.013C.855.011.836,0,.817,0A.817.817,0,0,0,0,.82V8.169a.823.823,0,0,0,.556.776l2.457.819a.845.845,0,0,0,.253.038.817.817,0,0,0,.816-.817V8.577H5.307A1.226,1.226,0,0,0,6.532,7.353V5.719a.408.408,0,0,0-.408-.408Zm0,0",
    transform: "translate(0 0)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M281.7,108.418l-1.633-1.633a.408.408,0,0,0-.7.289V108.3H277.74a.408.408,0,1,0,0,.816h1.633v1.225a.408.408,0,0,0,.7.289L281.7,109A.408.408,0,0,0,281.7,108.418Zm0,0",
    transform: "translate(-272.025 -104.62)",
    fill: "#424e55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorExitCircle);
export default __webpack_public_path__ + "static/media/door-exit_circle.f505d930199bb857a9bbd82780fd8611.svg";
export { ForwardRef as ReactComponent };